//export const apiBaseUrl = "https://localhost:7279/api/";
//export const apiBaseUrl = "https://abiolasoft-finance-ui-az.azurewebsites.net/api/";
export const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || "https://dev-ab-fin.azurewebsites.net/api/";
export const dashboardBaseUrl = process.env.REACT_APP_DASHBOARD_BASE_URL || "https://development--fingold.netlify.app/{accountIdentifier}";
